module.exports = __webpack_public_path__ + "media/images/cross-121965f4a8e0851eb64f1159b0ac3dbe.svg";